/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetTypeRouter_reports = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTypeRouter_reports",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "withWidgetData_reports",
      "args": null
    }
  ],
  "type": "ReportConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetTypeRouter/__generated__/WidgetTypeRouter_reports.graphql.js